import { useQuery } from "@apollo/client"
import css from "./PlaygroundPage.module.scss"
import { PlaygroundCountriesDocument } from "./PlaygroundQueries.generated"
import { useState } from "react"

/*
 * Denne siden blir bare brukt som eksempel-kode. Den blir filtrert ut ved produksjonssetting.
 *
 * Du kan gjøre hva du vil her.
 */

function PlagroundPage() {
  const [name, setName] = useState("N")
  const [queryCount, setQueryCount] = useState(0)

  const countries = useQuery(PlaygroundCountriesDocument, {
    onCompleted: () => setQueryCount((currentCount) => ++currentCount),
    variables: {
      where: {
        name: {
          contains: name,
        },
      },
    },
  })
  return (
    <div className={css.page}>
      <h1>Playground</h1>
      <section className={css.countriesSection}>
        <h2>Liste over land</h2>
        <small>Spørringen har kjørt {queryCount} ganger</small>

        <div>
          {/* 
        Eksempel på enkel bruk av input. 
        Merk at man bør vanligvis putte dette inn i et <form> og bruke en form for debounce.
        */}
          <label htmlFor="playground-country-search">Søk på land</label>
          <input
            type="search"
            placeholder="Søk på land"
            defaultValue={name}
            onChange={(e) => setName(e.currentTarget.value)}
          />
        </div>
        <ul>
          {countries.data?.countries?.map((country) => {
            return <li key={country.name}>{country.name}</li>
          })}
        </ul>
      </section>
    </div>
  )
}

export default PlagroundPage
